export const CART_HEADER_PX = "111px";

export const SHIPPING_INFO_FOOTER_PX = "178px";
